//
// create slice
// as centeralize between actions and reducers
//
// serviceActions module contains reducers and actions that
// created by createAsyncThunk from redux-toolkit
//
// for standard actions, that require other business logic
// can be put inside extraActions module
//
// export default will be reducers it self that processed by store
// other exports will contains actions that's dispatched from ReactComponent
//

import { createSlice } from '@reduxjs/toolkit';
import {
  qboFetchObjectsAsync,
  qboFetchObjectsExtraReducers,
} from './serviceActions/fetchQboObjectsAsync';
import {
  qboBackupNowRealmAsync,
  qboBackupNowRealmExtraReducers,
} from './serviceActions/backupNowAsync';

const initialState = {
  QboObjects: {
    companyName: null,
    backupStatus: null,
    lastCompletedBackupAt: null,
    value: [],
    nextLink: null,
    prevLink: null,
  },
  fetchingQboObjects: true,
  error: null,
};

const qboObjectsSlice = createSlice({
  name: 'QboObjects',
  initialState,
  reducers: {
    resetState() {
      return initialState;
    },
  },
  extraReducers: {
    ...qboFetchObjectsExtraReducers,
    ...qboBackupNowRealmExtraReducers,
  },
});

export const { resetState } = qboObjectsSlice.actions;
export { qboFetchObjectsAsync, qboBackupNowRealmAsync };
export default qboObjectsSlice.reducer;
